import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/context/AuthContext';
import { useAdminStatus } from '@/hooks/useAdminStatus';
import { useOrgRoles } from '@/hooks/useOrgRoles';
import { ScopeLoading } from '@/context/ClientScopeProvider';

export const BillingProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { isAdmin, isLoading: adminLoading } = useAdminStatus();
  const { has, isAnswered } = useOrgRoles();

  if (authLoading || adminLoading || !isAnswered) return <ScopeLoading />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isAdmin && !has('billing')) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
};
